import React, {useState, useEffect, useImperativeHandle} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from '../../utils/compose';
import { httpClient, paymentMethodsBaseUrl } from '../../http-client/http-client';
import { billingInfoActions } from '../../store/actions/billingInformation/billingInformation';
import DropIn from './DropIn';
import InlineSpinner from "../UI/InlineSpinner/InlineSpinner";

const AddBraintreeCard = props => {
  const { onReady, amount = 1, accessToken, billingInfo, language, onFetchBillingInformation } = props;
  const [ clientToken, setClientToken ] = useState(null);
  const [ instance, setInstance ] = useState(null);

  const uiLanguage = language === 'es' ? 'es_ES' : 'en_US';

  useImperativeHandle(props.innerRef, () => ({
    getPayload: async () => {
      if(instance === null)
        return Promise.reject('instance not initialized');

      return instance.requestPaymentMethod({
        threeDSecure: {
          amount: amount.toFixed(2),
          email: billingInfo.data.BillingInformation.Email,
          challengeRequested: true,
          billingAddress: {
            phoneNumber: `${billingInfo.data.BillingInformation.Phone}`,
            postalCode: billingInfo.data.BillingInformation.AddressZipCode || '',
            countryCodeAlpha2: billingInfo.data.BillingInformation.AddressCountryIsoCode || ''
          }
        },
      });
    }
  }))

  useEffect(() => {
    if(billingInfo.data === null) {
      onFetchBillingInformation()
    }
  }, [onFetchBillingInformation])

  useEffect(() => {
    let isActive = true;
    httpClient.post(`${paymentMethodsBaseUrl}/clientToken`, accessToken)
      .then(
        data => {
          if(isActive) {
            setClientToken(data.Token);
          }
        },
        error => {
          if(isActive) {
            onReady(false, error.HumanError);
          }
        }
      );

    return () => {
      isActive = false;
      onReady(false, null);
    }
  }, []);

  const notifyReady = (instance) => {
    setInstance(instance);
    onReady(true, null);
  }

  return (
    <>

      { clientToken !== null ? (
        <DropIn
          options={{
            authorization: clientToken,
            threeDSecure: true,
            card: {
              cardholderName: {
                required: true
              }
            },
            locale: uiLanguage
          }}
          onInstance={instance => notifyReady(instance)}
        />
      ) : <InlineSpinner size="small" align="center"/>}
    </>
  );
};

AddBraintreeCard.propTypes = {
  amount: PropTypes.number,
  onReady: PropTypes.func,
  innerRef: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  accessToken: state.oidc.user.access_token,
  billingInfo: state.billingInformation,
  language: state.settings.language
});

const mapDispatchToProps = (dispatch) => ({
  onFetchBillingInformation: () => dispatch(billingInfoActions.fetch())
});

const composed = compose(
  connect(mapStateToProps, mapDispatchToProps)
)(AddBraintreeCard);

export default composed;